import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
};

const setLink = (rel, href, hreflang) => {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const stripEn = (p) => p.replace(/^\/en(?=\/|$)/, "") || "/";

// SEO helper: applies title/description/keywords (with admin overrides),
// canonical, hreflang alternates (DE/EN), Open Graph and JSON-LD.
const Seo = ({ pageKey, title, description, keywords, jsonLd }) => {
  const { lang, t } = useLang();
  const location = useLocation();
  const ov = (pageKey && t && t._seo && t._seo[pageKey]) || {};
  const finalTitle = ov.title || title;
  const finalDesc = ov.description || description;
  const finalKw = ov.keywords || keywords;

  useEffect(() => {
    if (finalTitle) document.title = finalTitle;
    setMeta("name", "description", finalDesc);
    setMeta("name", "keywords", finalKw);
    setMeta("property", "og:title", finalTitle);
    setMeta("property", "og:description", finalDesc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:locale", lang === "de" ? "de_CH" : "en_US");

    const origin = window.location.origin;
    const current = location.pathname;
    const dePath = stripEn(current);
    const enPath = dePath === "/" ? "/en" : `/en${dePath}`;

    const canonical = origin + current;
    setLink("canonical", canonical);
    setMeta("property", "og:url", canonical);
    setLink("alternate", origin + dePath, "de");
    setLink("alternate", origin + enPath, "en");
    setLink("alternate", origin + dePath, "x-default");

    let script = document.getElementById("seo-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "seo-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    }
  }, [finalTitle, finalDesc, finalKw, lang, location.pathname, jsonLd]);

  return null;
};

export default Seo;
